import React from "react";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Hero from "components/hero/TwoColumnWithVideo.js";
import Features from "components/features/ThreeColSimple.js";
import MainFeature from "components/features/TwoColWithButton.js";
import MainFeature2 from "components/features/TwoColSingleFeatureWithStats2.js";
import TabGrid from "components/cards/TabCardGrid.js";
import Testimonial from "components/testimonials/ThreeColumnWithProfileImage.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import chefIconImageSrc from "images/loan.png";
import celebrationIconImageSrc from "images/training.png";
import shopIconImageSrc from "images/inscription.png";
import stockage from "images/in-stock.png";
import livraison from "images/cash-on-delivery.png";
import retraite from "images/retirement-plan.png";
import skincare from "images/concealer.png";
import vitamins from "images/vitamins.png";
import parfum from "images/parfum.png";
import necklace from "images/necklace.png";
import DesignIllustration from "images/image.svg";
import image2 from "images/image2.png";
import TabCardGrid2 from "./cards/TabCardGrid2";
import { useState, useEffect } from 'react';
import LightBuyer from "./headers/lightBuyer";
import Light from "./headers/light";
import LightAdmin from "./headers/lightAdmin";
import AnnouncementBanner from 'components/AnnouncementBanner';

export default () => {
  const Subheading = tw.span`tracking-wider text-sm font-medium`;
const HighlightedText = tw.span`bg-[#2c5a78] text-gray-100 px-4 transform -skew-x-12 inline-block`;
  const HighlightedTextInverse = tw.span`bg-gray-100 text-primary-500 px-4 transform -skew-x-12 inline-block`;
  const Description = tw.span`inline-block mt-8`;
  const imageCss = tw`rounded-4xl`;
    const [role, setRole] = useState('');
  useEffect(() => {
      const userRole = localStorage.getItem('role');
          setRole(userRole); // Set the role state based on what’s stored
  
    }, []);
  const token = localStorage.getItem('authToken');

  return (
    <AnimationRevealPage>
{/* Conditionally render Light, LightBuyer, or default to Light if no role */}
{role === 'admin' ? <LightAdmin /> : role === 'buyer' ? <LightBuyer /> : <Light />}
{/* {role === 'supplier' ? <Light /> : role === 'buyer' ? <LightBuyer /> : role === 'admin' ? <LightAdmin /> : <Light />} */}


      
      <Hero
        heading={<><HighlightedText>Bienvenue</HighlightedText>chez HbmDigital</>}

        description="le système le plus puissant de commerce électronique au Maroc.Inscription gratuite… Apprenez gratuitement… Gagnez sans risques
"
imageSrc={DesignIllustration} 
imageCss={imageCss}
        imageDecoratorBlob={true}
        primaryButtonText="Rejoignez-nous maintenant"
        primaryButtonStyles="bg-red-500 hover:bg-red-700 text-white font-bold py-3 px-6 rounded-lg"

        watchVideoButtonText="Regarder la video"
      />
            <AnnouncementBanner />

      <MainFeature
        // subheading={<Subheading>Established Since 2014</Subheading>}
        heading={
          <>
{/* Qui sommes-nous */}
<wbr /> <HighlightedText>Qui sommes-nous</HighlightedText>
          </>
        }
        description={
          <Description>
           HbmDigital est votre meilleur partenaire pour vous lancer dans le monde du commerce électronique, grâce à l'expertise de ses fondateurs qui ont des années d'expérience dans ce domaine.
            <br />
            <br />
            Nous vous proposons de rejoindre notre entreprise pour entamer un parcours d'apprentissage et de gain sans aucun paiement préalable ou investissement.
            </Description>
        }
        buttonRounded={false}
        textOnLeft={false}
        primaryButtonText="Nos produits"
        imageSrc={image2}
        imageCss={imageCss}
        imageDecoratorBlob={true}
        imageDecoratorBlobCss={tw`left-1/2 -translate-x-1/2 md:w-32 md:h-32 opacity-25`}
      />
      {/* TabGrid Component also accepts a tabs prop to customize the tabs and its content directly. Please open the TabGrid component file to see the structure of the tabs props.*/}
      {/* <TabGrid
        heading={
          <>
            Checkout our <HighlightedText>menu.</HighlightedText>
          </>
        }
      /> */}
            <TabCardGrid2
        heading={
          <>
            Découvrir nos <HighlightedText>produits.</HighlightedText>
          </>
        }
      />
      <Features
        heading={
          <>
            Pourquoi nous<HighlightedText>choisir.</HighlightedText>
          </>
        }
        cards={[
          {
            imageSrc: shopIconImageSrc,
            title: "Inscription gratuite",
            description: "Rejoignez-nous sans frais.",
            url: ""
          },
          {
            imageSrc: chefIconImageSrc,
            title: "Pas besoin de capital",
            description: "Démarrez sans investissement.",
            url: ""
          },
          {
            imageSrc: celebrationIconImageSrc,
            title: "Formation gratuite",
            description: "Apprenez gratuitement.",
            url: ""
          }
          ,
          {
            imageSrc: stockage,
            title: "Stockage gratuit",
            description: "Nous stockons pour vous.",
            url: ""
          },
          {
            imageSrc: livraison,
            title: "Livraison dans toutes les villes et villages",
            description: "Expédition partout.",
            url: ""
          },
          {
            imageSrc: retraite,
            title: " Retrait des gains deux fois par mois",
            description: "Paiement bimensuel.",
            url: ""
          }
        ]}

        imageContainerCss={tw`p-2!`}
        imageCss={tw`w-20! h-20!`}
      />
<Features
  heading={
    <>
      Nos<HighlightedText>produits.</HighlightedText>
    </>
  }
  cards={[
    { imageSrc: skincare, title: "Produits cosmétiques", url: "" },
    { imageSrc: vitamins, title: "Compléments alimentaires", url: "" },
    { imageSrc: parfum, title: "Parfums",  url: "" },
    { imageSrc: necklace, title: "Accessoires et bijoux", url: "" },
  ]}
  imageContainerCss={tw`p-2!`}
  imageCss={tw`w-20! h-20!`}
  containerCss={tw`grid grid-cols-4 grid-rows-2 gap-4`} // ✅ Ici, on force 4 cartes en ligne 1 et 2 cartes en ligne 2
/>

      {/* <MainFeature2
        subheading={<Subheading>A Reputed Brand</Subheading>}
        heading={<>Why <HighlightedText>Choose Us ?</HighlightedText></>}
        statistics={[
          {
            key: "Orders",
            value: "94000+",
          },
          {
            key: "Customers",
            value: "11000+"
          },
          {
            key: "Chefs",
            value: "1500+"
          }
        ]}
        primaryButtonText="Order Now"
        primaryButtonUrl="https://order.now.com"
        imageInsideDiv={false}
        imageSrc="https://images.unsplash.com/photo-1414235077428-338989a2e8c0?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEzNzI2fQ&auto=format&fit=crop&w=768&q=80"
        imageCss={Object.assign(tw`bg-cover`, imageCss)}
        imageContainerCss={tw`md:w-1/2 h-auto`}
        imageDecoratorBlob={true}
        imageDecoratorBlobCss={tw`left-1/2 md:w-32 md:h-32 -translate-x-1/2 opacity-25`}
        textOnLeft={true}
      /> */}
      {/* <Testimonial
        subheading=""
        heading={<>Nos <HighlightedText>produits</HighlightedText></>}
      /> */}

      <Footer />
    </AnimationRevealPage>
  );
}
